import { type FC, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { IconButton, Tooltip } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { MediaLibraryStore } from 'widgets/MediaLibrary/store/mediaLibraryStore'
import {
  type IMediaLibraryStoreProps,
  type IOnAddAttachment,
  MediaLibrarySelectMode,
  MediaLibraryVariant,
} from 'widgets/MediaLibrary/types/types'
import { usePresentationModeContext } from 'widgets/PresentationMode'

type MediaLibraryRinglessSelectButtonProps = {
  onAddAttachment: IOnAddAttachment
  onClick: () => void
  mediaLibraryConfiguration?: Partial<IMediaLibraryStoreProps>
}

export const MediaLibraryRinglessSelectButton: FC<MediaLibraryRinglessSelectButtonProps> = observer(
  ({ onAddAttachment, onClick, mediaLibraryConfiguration: mediaLibraryConfigurationProps }) => {
    const entities = useEntitiesContext()
    const presentationStore = usePresentationModeContext()
    const mediaLibraryConfiguration: IMediaLibraryStoreProps = {
      mediaLibraryVariant: MediaLibraryVariant.RinglessSelect,
      onAddAttachment: onAddAttachment,
      selectMode: MediaLibrarySelectMode.Single,
      ...mediaLibraryConfigurationProps,
    }

    const [store] = useState(
      () => new MediaLibraryStore(mediaLibraryConfiguration, entities, presentationStore)
    )

    return (
      <Tooltip label={'Add media'} placement={'top'}>
        <IconButton
          icon={'addCircle'}
          variant={'icon'}
          color={'secondary'}
          onClick={() => {
            store.handleOpenMediaLibraryModal()
            onClick()
          }}
          ariaLabel='MediaAction_addMedia'
        />
      </Tooltip>
    )
  }
)
